import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Button } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { DataGrid } from "@mui/x-data-grid";
import EmployeeNamePic from "../../EmployeeNamePic/EmployeeNamePic";
import { fonts, themes } from "../../../themes/themes";
import SearchComponent from "../../SearchComponent";
import CustomAutoComplete from "../../CustomAutoComplete/CustomAutoComplete";
import FeedbackDetailModalController from "../../../Modals/PerofomanceModals/FeedbackDetailModal/FeedbackDetailModalController";
import FeedbackEditActionModalController from "../../../Modals/PerofomanceModals/FeedbackEditActionModal/FeedbackEditActionModalController";
import GiveFeedbackModalController from "../../../Modals/PerofomanceModals/GiveFeedbackModal/GiveFeedbackModalController";

interface Prop {
  trans: any;
}
function FeedbackPerfomancePresenter({ trans }: Prop) {
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openGiveFeedbackModal, setOpenGiveFeedbackModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  const { t, i18n } = useTranslation();
  const tableColumns: any = [
    {
      field: "date",
      headerName: "Date",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "empName",
      headerName: "Emp Name",

      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
      renderCell: (params: any) => {
        return (
          <EmployeeNamePic
            name={params.row.name}
            picture={params.row.profilePic}
          />
        );
      },
    },
    {
      field: "feedbackFor",
      headerName: "Feedback For",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "goals",
      headerName: "Goals",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "task",
      headerName: "Task",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "kpis",
      headerName: "KPIs",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },
    {
      field: "comments",
      headerName: "Comments",
      width: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
      headerClassName: "header",
      height: 70,
    },

    {
      field: "action",
      flex: 1,
      headerName: "Action",
      headerClassName: "header",
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => {
        return (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box
              style={{
                border: "1px solid #E6E8EF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={() => setOpenDeleteModal(true)}
            >
              <i
                className="las la-trash-alt"
                style={{ color: themes.lightRedSubtittle }}
              />
            </Box>
            <Box
              style={{
                border: "1px solid #E6E8EF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2px",
                borderRadius: "4px",
                marginLeft: "0.5em",
                cursor: "pointer",
              }}
              onClick={() => setOpenEditModal(true)}
            >
              <i
                className="las la-pencil-alt"
                style={{ color: themes.green }}
              />
            </Box>
            <Box
              style={{
                border: "1px solid #E6E8EF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "2px",
                borderRadius: "4px",
                marginLeft: "0.5em",
                cursor: "pointer",
              }}
              onClick={() => setOpenViewModal(true)}
            >
              <i className="las la-eye" style={{ color: themes.primaryMain }} />
            </Box>
          </Box>
        );
      },

      width: 200,
      height: 70,
    },
  ];

  const historyData: any = [
    {
      id: 1,
      date: "20 Jan, 2022",
      name: "Mitchel Candy",
      profilePic: "",
      feedbackFor: "Performance Evaluation 2022",
      goals: "Complete sprint",
      task: "UI Dashboard",
      kpis: "Test Kpi",
      comments: "view it",
    },
  ];
  return (
    <>
      <Box
        sx={{
          padding: "1em",
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 1px 1px #0000001A",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <Grid container spacing={2} style={{display:'flex',alignItems:'center'}}>
          <Grid item xs={5} >
            <SearchComponent />
          </Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={2} >
            <CustomAutoComplete label="Filter by KPI's" size="medium" required={false}/>
          </Grid>
          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              startIcon={
                <i className="las la-plus" style={{ color: "white" }} />
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "Center",
                backgroundColor: themes.primaryMain,
                color: "white",
                textTransform: "capitalize",
                height:'47px',
                padding:'1em'
              }}
              onClick={() => setOpenGiveFeedbackModal(true)}
            >
              Give Feedback
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                "& .header": {
                  backgroundColor: "#F5F5F5",
                },
              }}
            >
              <DataGrid
                sx={{
                  color: "#081735",
                  font: "normal normal normal 14px/24px Lato;",
                }}
                autoHeight
                disableExtendRowFullWidth
                disableSelectionOnClick
                rows={historyData}
                columns={tableColumns}
                componentsProps={{
                  pagination: {
                    labelRowsPerPage: t("Rows per page"),
                  },
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {openViewModal && (
        <FeedbackDetailModalController
          closeModal={() => setOpenViewModal(false)}
          isModalOpen={openViewModal}
          trans={trans}
        />
      )}
      {openEditModal && (
        <FeedbackEditActionModalController
          closeModal={() => setOpenEditModal(false)}
          isModalOpen={openEditModal}
          trans={trans}
        />
      )}
      {openGiveFeedbackModal && (
        <GiveFeedbackModalController
          closeModal={() => setOpenGiveFeedbackModal(false)}
          isModalOpen={openGiveFeedbackModal}
          trans={trans}
        />
      )}
    </>
  );
}
export default FeedbackPerfomancePresenter;
